import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import "./exploreService.css";
import { CiLocationOn } from "react-icons/ci";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Vendorlist } from "../../env/action";

const ExploreServices = () => {
  const navigate = useNavigate();
  const [isDragging, setIsDragging] = useState(false);
  const [vendor, setVendor] = useState([]);
  useEffect(() => {
    Vendorlist((res) => {
      if (res.status === 1) {
        setVendor(res.data);
        console.log(res.data, "-------dataa");
      } else {
        console.log("No vendor found");
      }
    });
  }, []);

  // Slider settings
  const staffSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  // Handle card click navigation
  // const handleCardClick = (id, company_name) => {
  //   if (!isDragging) {
  //     const kebabCaseStr = company_name.toLowerCase().replace(/\s+/g, "-");
  //     navigate(`/${kebabCaseStr}`, { state: { company_name, id } });
  //   }
  // };

  return (
    <Container className="exploreService mt-5">
      <div className="text-center mb-4">
        <span className="primary-color">NURSING SERVICE</span>
        <h2>Find Service Provider</h2>
        <p>
          Explore some of the best services from around the city from our
          partners and friends.
        </p>
      </div>

      {/* Render slider only if services exist */}
      {vendor.length > 0 && (
        <Slider {...staffSliderSettings}>
          {vendor.map((item) => (
            <div className="card-container mt-3" key={item.id}>
              <Card
                className="card fscrd"
                onMouseDown={() => setIsDragging(false)}
                onMouseMove={() => setIsDragging(true)}
              // onMouseUp={() => handleCardClick(item.id, item.company_name)}
              >
                <div className="card-img">
                  <img
                    variant="top"
                    src={item.vendor_logo}
                    className="card-img h-100"
                    alt={item.company_name}
                    style={{ objectFit: "cover" }}
                  />
                </div>
                <Card.Body className="text-left">
                  <Card.Title>{item.company_name}</Card.Title>
                  <Card.Text>
                    {" "}
                    <CiLocationOn /> {item.address}{" "}
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Slider>
      )}
    </Container>
  );
};

export default ExploreServices;
